function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 620,
    height: 620,
    viewBox: "0 0 62 62",
    id: "svg0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "shadowGradient"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop17",
    style: {
      stopColor: "#c0c0c0",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop19",
    style: {
      stopColor: "#c0c0c0",
      stopOpacity: 1
    },
    offset: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop21",
    style: {
      stopColor: "#c0c0c0",
      stopOpacity: 0
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 42.986301,
    y1: 7.0127001,
    x2: 22.0144,
    y2: 51.987099,
    id: "fieldGradient",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop7",
    style: {
      stopColor: "#2f82e0",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop9",
    style: {
      stopColor: "#164172",
      stopOpacity: 1
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 54.509937,
    y1: 41.179295,
    x2: 9.5471001,
    y2: 16.248501,
    id: "edgeGradient",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop12",
    style: {
      stopColor: "#2f82e0",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop14",
    style: {
      stopColor: "#164172",
      stopOpacity: 1
    },
    offset: 1
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 29.5,
    r: 26.5,
    transform: "matrix(1.0648,0,0,1.064822,-2.1,1.0864)",
    id: "shadow",
    style: {
      fill: "url(#shadowGradient)",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 25.8,
    id: "field",
    style: {
      fill: "url(#fieldGradient)",
      fillOpacity: 1,
      stroke: "url(#edgeGradient)",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23,25 35,25 35,44 39,44 39,48 23,48 23,44 27,44 27,28 23,28 23,25 ",
    id: "polygon26",
    style: {
      fill: "#ffffff",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 17,
    r: 4,
    id: "circle28",
    style: {
      fill: "#ffffff",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.08,
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      strokeWidth: 2,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "path3146",
    d: "M 53.280498,39.774565 A 24.705584,24.705584 0 1 1 53.461336,39.313236",
    transform: "matrix(1.0047727,0,0,1.0047762,0.4845556,0.2869342)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.8ba6931752680689f5b7387ad1aed858.svg";
export { ForwardRef as ReactComponent };